import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const RANGES = [7, 30, 90];

export const FunnelPanel = () => {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/admin/funnel?days=${days}`).then(({ data: d }) => setData(d)).catch(() => setData({ steps: [] }));
  }, [days]);
  const top = Math.max(0, ...(data?.steps || []).map((s) => s.count));
  return (
    <div className="mt-6 rounded-3xl border bg-white p-6" data-testid="funnel-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <h3 className="font-medium">Dalla visita all'iscrizione</h3>
          <p className="text-xs text-slate-500">Conteggio anonimo, senza cookie di profilazione. Bot e anteprime dei link esclusi.</p>
        </div>
        <div className="flex gap-1 rounded-full bg-slate-100 p-1">
          {RANGES.map((r) => (
            <button key={r} onClick={() => setDays(r)} className={`rounded-full px-3 py-1 text-xs transition-colors ${days === r ? "bg-white shadow-sm font-medium" : "text-slate-500"}`} data-testid={`funnel-range-${r}`}>{r} giorni</button>
          ))}
        </div>
      </div>
      {!data ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : (
        <ol className="space-y-2.5">
          {data.steps.map((s) => {
            const pct = top ? Math.round((s.count / top) * 1000) / 10 : 0;
            return (
              <li key={s.key} data-testid={`funnel-step-${s.key}`}>
                <div className="flex justify-between text-sm"><span>{s.label}</span><span className="font-medium">{s.count} <span className="text-xs text-slate-400 font-normal">{top ? `${pct}%` : ""}</span></span></div>
                <div className="mt-1 h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full rounded-full bg-[#1E3A8A] transition-[width] duration-500" style={{ width: `${Math.min(pct, 100)}%` }} /></div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};
